const localizers = {
  'Alerts.noAlerts.txt': () => `Für diesen Bericht wurden keine Alerts definiert.`,
  'BirdImage.image.txt': () => `Bild`,
  'BirdText.editable.tooltip.txt': () => `Doppelklicken, um Text zu bearbeiten`,
  'ComboBox.clearFilter.txt': () => `Filter löschen`,
  'ComboBox.defautValueNoData.fmt': ({categoryValue}) => `${categoryValue} (Keine Daten)`,
  'ContextMenu.selectAll.txt': () => `Alles auswählen`,
  'ContextMenu.clearSelection.txt': () => `Auswahl löschen`,
  'ContextMenu.exportImage.txt': () => `Als Bild exportieren`,
  'ContextMenu.sortAscending.fmt': ({role}) => `${role}: Aufsteigend`,
  'ContextMenu.sortDescending.fmt': ({role}) => `${role}: Absteigend`,
  'ContextMenu.sortAddAscending.fmt': ({role}) => `${role}: Aufsteigend hinzufügen`,
  'ContextMenu.sortAddDescending.fmt': ({role}) => `${role}: Absteigend hinzufügen`,
  'ContextMenu.removeSortItem.fmt': ({role}) => `${role} aus Sortierung entfernen`,
  'ContextMenu.removeSortLevel.txt': () => `Sortierebene entfernen`,
  'ContextMenu.sort.txt': () => `Sortieren`,
  'ContextMenu.selectShortestPath.txt': () => `Kürzesten Pfad auswählen`,
  'ContextMenu.explain.txt': () => `Daten erklären`,
  'ContextMenu.explainRole.txt': ({role}) => `Erklären von ${role}...`,
  'ContextMenu.manageColumns.txt': () => `Spalten verwalten`,
  'ContextMenu.includeMissingValues.txt': () => `Fehlende Werte einbeziehen`,
  'DrillableTooltip.drill.txt': () => `DRILLEN`,
  'DrillableTooltip.tooltip.txt': () => `QUICKINFO`,
  'DrillableTooltip.links.txt': () => `VERKNÜPFUNGEN`,
  'DrillableTooltip.section.link.fmt': ({page}) => `Seitenverknüpfung auf ${page}`,
  'DrillableTooltip.report.link.fmt': ({report}) => `Berichtsverknüpfung auf ${report}`,
  'DrillableTooltip.external.link.fmt': ({url}) => `Externe Verknüpfung auf ${url}`,
  'DrillableTooltip.notAvailable.txt': () => `Nicht verfügbar`,
  'Breadcrumb.all.fmt': ({label}) => `Alle ${label}`,
  'BrowserCheck.title.txt': () => `WebGL-Prüfung`,
  'BrowserCheck.msg.txt': () => `WebGL ist entweder deaktiviert oder wird von Ihrem Browser nicht unterstützt.   \nAuf OK klicken, um den Bericht im klassischen Viewer anzuzeigen.`,
  'EmailUtil.subject.multiple.txt': () => `Zu prüfende Berichte`,
  'EmailUtil.tooLongEmail.txt': () => `Maximal zulässige Länge für E-Mails wurde überschritten. Reduzieren Sie die Anzahl der zu sendenden Berichte.`,
  'HiddenSectionDialog.close.txt': () => `Schließen`,
  'HiddenSectionDialog.export.txt': () => `Als PDF exportieren`,
  'InfoPanel.information.txt': () => `Informationen`,
  'InfoPanel.comments.txt': () => `Kommentare`,
  'InfoPanel.alerts.txt': () => `Alerts`,
  'IncomingFilters.promptbars.txt': () => `Eingabeaufforderungsleisten`,
  'Information.title.txt': () => `Titel`,
  'Information.name.txt': () => `Name:`,
  'Information.description.txt': () => `Beschreibung:`,
  'Information.displayRules.txt': () => `Anzeigeregeln:`,
  'Information.graphLevel.txt': () => `Diagrammebene`,
  'Information.reportLevel.txt': () => `Berichtebene`,
  'Information.legend.txt': () => `Legende`,
  'Information.incomingFilters.txt': () => `Angewendete Filter:`,
  'Information.noIncomingFilters.txt': () => `Keine Filter angewendet`,
  'Information.dataSourceFilters.txt': () => `Datenquellenfilter:`,
  'Information.interactiveFilters.txt': () => `Interaktive Filter:`,
  'MobileContainer.mobileBIMessage.txt': () => `Greifen Sie von Ihrem mobilen Endgerät auf SAS-Berichte zu.`,
  'ObjectTypes.report.txt': () => `Bericht`,
  'ObjectTypes.Report.BI.txt': () => `SAS Report (2G)`,
  'ObjectTypes.Report.StoredProcess.txt': () => `Stored Process-Bericht`,
  'ObjectTypes.StoredProcess.txt': () => `Stored Process`,
  'MissingValues.label.txt': () => `(fehlende Werte)`,
  'PromptContainer.apply.txt': () => `OK`,
  'PromptContainer.cancel.txt': () => `Abbrechen`,
  'PromptContainer.close.txt': () => `Schließen`,
  'TextFieldTypeAhead.validation.range.fmt': ({min, max}) => `Wert muss eine Zahl zwischen ${min} und ${max} (einschließlich) sein.`,
  'TextFieldTypeAhead.validation.numeric.txt': () => `Geben Sie einen gültigen numerischen Wert an.`,
  'TextFieldTypeAhead.validation.string.txt': () => `Der Wert ist für die zugewiesenen Daten ungültig.`,
  'TextFieldTypeAhead.categoryAndMeasureTooltip.fmt': ({categoryLabel, measureLabel}) => `Eingabe: ${categoryLabel}, ${measureLabel}`,
  'TextFieldTypeAhead.categoryTooltip.fmt': ({categoryLabel}) => `Eingabe: ${categoryLabel}`,
  'TextFieldTypeAhead.placeholder.fmt': ({placeholderLabel}) => `${placeholderLabel} eingeben...`,
  'RangeSlider.tooltip.fmt': ({label, min, max}) => `${label}: ${min}–${max}`,
  'Slider.missingValues.txt': () => `Fehlende Werte`,
  'Slider.missingValues.tooltip.fmt': ({rangeLabel}) => `${rangeLabel} einschließlich fehlender Werte`,
  'PromptElement.categoryLabelValueAndMeasureLabelValueTooltip.fmt': ({categoryLabel, categoryValue, measureLabel, measureValue}) => `${categoryLabel}: ${categoryValue}, ${measureLabel}: ${measureValue}`,
  'PromptElement.categoryLabelValueTooltip.fmt': ({categoryLabel, categoryValue}) => `${categoryLabel}: ${categoryValue}`,
  'ReportContainer.back.txt': () => `Zurück`,
  'ReportContainer.reportCorrupted.txt': () => `BERICHT BESCHÄDIGT`,
  'ReportContainer.themeLoadFailed.txt': () => `Laden des Berichtsschemas ist fehlgeschlagen.`,
  'ReportContainer.restoreButton.tip.txt': () => `Bericht wiederherstellen`,
  'ReportContainer.restoreButtonAriaAnnounce.txt': () => `Bericht wiederhergestellt`,
  'ReportContainer.renderError.txt': () => `Es ist ein Fehler aufgetreten. Der Bericht konnte nicht angezeigt werden.`,
  'ReportContainer.component.renderError.txt': () => `Es ist ein Fehler aufgetreten. Die Komponente konnte nicht dargestellt werden.`,
  'ReportContentPage.open.txt': () => `Öffnen...`,
  'ReportContentPage.refreshReport.txt': () => `Bericht aktualisieren`,
  'ReportContentPage.editReport.txt': () => `Bericht bearbeiten`,
  'ReportContentPage.print.txt': () => `Drucken...`,
  'ReportContentPage.email.txt': () => `E-Mail...`,
  'ReportContentPage.export.txt': () => `Export nach Excel...`,
  'ReportContentPage.reportProperties.txt': () => `Berichtseigenschaften`,
  'ReportContentPage.shareReport.txt': () => `Bericht teilen`,
  'ReportContentPage.enableOverlays.txt': () => `Objektüberlagerung aktivieren`,
  'ReportContentPage.disableOverlays.txt': () => `Objektüberlagerung deaktivieren`,
  'ReportContentPage.link.txt': () => `Verknüpfung...`,
  'ReportContentPage.settings.txt': () => `Einstellungen...`,
  'ReportContentPage.editPlayback.txt': () => `Wiedergabe bearbeiten`,
  'ReportContentPage.playReport.txt': () => `Bericht abspielen`,
  'ReportContentPage.showFiltersButton.tip.txt': () => `Abfragefilter anzeigen`,
  'ReportContentPage.hideFiltersButton.tip.txt': () => `Abfragefilter ausblenden`,
  'ReportContentPage.reportFilters.txt': () => `Berichtebene`,
  'ReportContentPage.pageFilters.txt': () => `Seitenebene`,
  'ReportContentPage.refreshRequired.txt': () => `Bericht muss aktualisiert werden`,
  'ReportContentPage.infoButton.tip.txt': () => `Informationsfenster`,
  'ReportContentPage.backButton.tip.txt': () => `Alle Berichte anzeigen`,
  'ReportContentPage.overflowMenuButton.tip.txt': () => `Weitere Optionen`,
  'ReportContentPage.itemGroupName.txt': () => `Berichte`,
  'ReportContentPage.maximizeButton.tip.txt': () => `Bericht maximieren`,
  'ReportContentPage.closeButton.txt': () => `Bericht schließen`,
  'ReportContentPage.maximizeButtonAriaAnnounce.txt': () => `Bericht maximiert`,
  'ReportContentPage.resetReportState.txt': () => `Standardberichtszustand wiederherstellen`,
  'ReportContentPage.summary.txt': () => `Zusammenfassung anzeigen`,
  'ReportManagerPage.objectMenu.open.txt': () => `Öffnen`,
  'ReportManagerPage.objectMenu.edit.txt': () => `Bearbeiten`,
  'ReportManagerPage.objectMenu.summary.txt': () => `Zusammenfassung`,
  'ReportManagerPage.objectMenu.properties.txt': () => `Eigenschaften`,
  'ReportManagerPage.objectMenu.email.txt': () => `E-Mail...`,
  'ReportManagerPage.objectMenu.print.txt': () => `Drucken`,
  'ReportManagerPage.browseReportsButton.txt': () => `Berichte durchsuchen`,
  'ReportManagerPage.newReportButton.txt': () => `Neuer Bericht`,
  'ReportManagerPage.emptyView.message.txt': () => `Keine Berichte gefunden.`,
  'ReportManagerPage.emptyView.browseReportsButton.txt': () => `Nach Berichten suchen`,
  'ReportManagerPage.tableView.name.txt': () => `Name`,
  'ReportManagerPage.tableView.author.txt': () => `Autor`,
  'ReportManagerPage.tableView.lastModified.txt': () => `Zuletzt geändert`,
  'ReportManagerPage.openButton.tip.txt': () => `Bericht öffnen`,
  'ReportManagerPage.emailButton.tip.txt': () => `Bericht per E-Mail versenden`,
  'ReportManagerPage.printButton.tip.txt': () => `Bericht als PDF erstellen`,
  'ReportManagerPage.propertiesButton.tip.txt': () => `Berichteigenschaften`,
  'ReportObject.multipleReferences.error.txt': () => `Berichtsobjekte können nicht in mehreren Kontexten verwendet werden.`,
  'ReportObject.notFound.error.txt': () => `Der Objektname wurde im angegebenen Bericht nicht gefunden.`,
  'ReportObject.invalidPage.error.txt': () => `Die angegebene Seite ist ungültig.`,
  'ReportPropertiesDialog.open.txt': () => `Öffnen`,
  'ReportPropertiesDialog.close.txt': () => `Schließen`,
  'ReportPropertiesDialog.name.txt': () => `Name:`,
  'ReportPropertiesDialog.description.txt': () => `Beschreibung:`,
  'ReportPropertiesDialog.keywords.txt': () => `Schlüsselwörter:`,
  'ReportPropertiesDialog.type.txt': () => `Typ:`,
  'ReportPropertiesDialog.location.txt': () => `Speicherort:`,
  'ReportPropertiesDialog.createdBy.txt': () => `Erstellt von:`,
  'ReportPropertiesDialog.dateCreated.txt': () => `Erstellt am:`,
  'ReportPropertiesDialog.modifiedBy.txt': () => `Geändert von:`,
  'ReportPropertiesDialog.dateModified.txt': () => `Geändert am:`,
  'ReportSections.newPageButton.txt': () => `Neue Seite`,
  'ReportSections.closeTab.tooltip.txt': () => `Seite löschen`,
  'ReportSections.menuButton.tooltip.fmt': ({label}) => `${label}-Menü`,
  'ReportSummaryDialog.title.txt': () => `Zusammenfassung`,
  'ReportSummaryDialog.open.txt': () => `Öffnen`,
  'ReportSummaryDialog.cancel.txt': () => `Abbrechen`,
  'ReportSummaryDialog.close.txt': () => `Schließen`,
  'ReportSummaryDialog.noSummary.txt': () => `Keine Zusammenfassung verfügbar.`,
  'ReportTileBody.modifiedBy.txt': () => `Geändert von:`,
  'ReportTileBody.lastModified.txt': () => `Letzte Änderung:`,
  'VAViewerSettingsProvider.reportViewer.txt': () => `SAS Report Viewer`,
  'VAViewerSettingsProvider.reportRefreshSettings.txt': () => `Berichtsaktualisierung`,
  'VAViewerSettingsProvider.reportAutoRefresh.txt': () => `Automatische Berichtsaktualisierung`,
  'VAViewerSettingsProvider.reportRefreshFrequency.txt': () => `Aktualisierungsintervall in Minuten:`,
  'VAViewerSettingsProvider.alert.group.label.txt': () => `Alert-Benachrichtigungen`,
  'VAViewerSettingsProvider.alert.field.label.txt': () => `Standard Alert-Benachrichtigungen auswählen:`,
  'VAViewerSettingsProvider.alert.email.txt': () => `E-Mails senden`,
  'VAViewerSettingsProvider.alert.sms.txt': () => `SMS-Mitteilungen senden`,
  'VAViewerSettingsProvider.alert.system.txt': () => `Administratorstandard`,
  'VAViewerSettingsProvider.generalSettings.txt': () => `Schemata`,
  'VAViewerSettingsProvider.enableHighContrast.txt': () => `Berichtsschema überschreiben und SAS High Contrast verwenden`,
  'ViewerBusyDialog.openReport.txt': () => `Bericht öffnen...`,
  'ViewerBusyDialog.prepareExport.txt': () => `Export wird vorbereitet...`,
  'ViewerBusyDialog.preparePrint.txt': () => `Drucken wird vorbereitet...`,
  'PDFGeneration.printingReport.txt': () => `Bericht wird im PDF-Format erstellt. Die Datei steht in Kürze zum Download bereit.`,
  'PDFGeneration.fileName.fmt': ({fileName, date}) => `${fileName} am ${date}`,
  'VisualElementActionUtil.actionMenuLabel.txt': () => `Wählen Sie eine Aktion aus`,
  'VisualElementActionUtil.hierarchyExhausted.txt': () => `Unterste Ebene der Hierarchie wurde erreicht.`,
  'VisualElementActionUtil.hierarchiesExhausted.txt': () => `Unterste Ebene aller Hierarchien wurde erreicht.`,
  'VisualElementActionUtil.drillLabel.fmt': ({value}) => `Drillen in ${value}`,
  'SaveImageUtil.snapshot.fmt': ({a0, a1, a2}) => `Snapshot von ${a0} ${a1} erstellt am ${a2}`,
  'ObjectToolbarIcon.SaveImageTooltip.txt': () => `Bild speichern`,
  'ObjectToolbarIcon.PrintObject.txt': () => `Objekt drucken...`,
  'ObjectToolbarIcon.ShareObject.txt': () => `Objekt freigeben...`,
  'ObjectToolbarIcon.OverflowButton.default.txt': () => `Mehr`,
  'ObjectToolbarIcon.OverflowButton.labeled.fmt': ({label}) => `Objektmenü für ${label}`,
  'ObjectToolbarIcon.Accelerator.txt': () => `Anzeigen mit SAS® Graphics Accelerator`,
  'ZoomControl.button.tip.txt': () => `Zoomen`,
  'ZoomControl.button.zoomin.txt': () => `Hineinzoomen`,
  'ZoomControl.button.zoomout.txt': () => `Herauszoomen`,
  'ZoomControl.button.display.txt': () => `Zoomsteuerungen`,
  'ZoomControl.button.reset.txt': () => `Zoom zurücksetzen`,
  'ExpandControl.button.expand.txt': () => `Ansicht maximieren`,
  'ExpandControl.button.restore.txt': () => `Ansicht wiederherstellen`,
  'ExpandControl.button.expand.tip.txt': () => `Maximieren`,
  'ExpandControl.button.restore.tip.txt': () => `Wiederherstellen`,
  'ReportVisualContainer.sectionLink.notAllowed.maximize.txt': () => `Seitenverknüpfungen können nicht ausgeführt werden, während dieses Objekt maximiert ist.`,
  'DragModeControl.button.pan.tip.txt': () => `Schwenken`,
  'DragModeControl.button.circular.tip.txt': () => `Kreisförmige Auswahl`,
  'DragModeControl.button.freeform.tip.txt': () => `Freiformauswahl`,
  'DragModeControl.button.rectangular.tip.txt': () => `Rechteckige Auswahl`,
  'DragModeControl.button.zoom.tip.txt': () => `Rechteck zoomen`,
  'ReportXMLDialog.title.txt': () => `Bericht-XML`,
  'ReportXMLDialog.closeButton.txt': () => `Schließen`,
  'ReportXMLDialog.copyButton.txt': () => `In Zwischenablage kopieren`,
  'ReportXMLDialog.error.txt': () => `Fehler beim Laden der Bericht-XML`,
  'ErrorDialog.error.txt': () => `Fehler aufgetreten. Wenden Sie sich an Ihren Systemadministrator.`,
  'Application.banner.txt': () => `SAS® Report Viewer`,
  'Application.wip.banner.txt': () => `SAS® Visual Analytics - Report Viewer`,
  'Application.productName.txt': () => `SAS® Visual Analytics`,
  'OpenReportDialog.title.txt': () => `Bericht öffnen`,
  'OpenReportDialog.reports.txt': () => `Berichte:`,
  'OpenReportDialog.cancel.txt': () => `Abbrechen`,
  'OpenReportDialog.ok.txt': () => `OK`,
  'AriaLive.numberOfObjectsUpdated.fmt': ({count}) => `${count} Objekte wurden aktualisiert`,
  'AriaLive.oneObjectUpdated.txt': () => `1 Objekt wurde aktualisiert`,
  'AriaLive.reportOpened.txt': () => `Bericht wurde geöffnet`,
  'AriaLive.reportClosed.txt': () => `Bericht wurde geschlossen`,
  'ExportData.generating.txt': () => `Export wird generiert. Die Datei steht in Kürze zum Download bereit.`,
  'ExportData.warning.txt': () => `Fehler bei der Generierung der Daten`,
  'ExportData.nodata.txt': () => `Keine Daten für Export vorhanden`,
  'ExportData.exportData.txt': () => `Daten exportieren...`,
  'PlaybackAnimationDialog.saveButton.txt': () => `Speichern`,
  'PlaybackAnimationDialog.cancelButton.txt': () => `Abbrechen`,
  'PlaybackAnimationDialog.playButton.txt': () => `Bericht abspielen`,
  'PlaybackAnimationDialog.title.txt': () => `Wiedergabe bearbeiten`,
  'PlaybackAnimationDialog.transitionUnit.label.txt': () => `Übergangselement:`,
  'PlaybackAnimationDialog.transitionUnit.page.txt': () => `Seite`,
  'PlaybackAnimationDialog.transitionUnit.object.txt': () => `Objekt`,
  'PlaybackAnimationDialog.secondsPerUnit.label.txt': () => `Sekunden je Element:`,
  'PlaybackAnimationDialog.showMaximized.label.txt': () => `Maximierte Objekte anzeigen:`,
  'PlaybackAnimationDialog.showCanvasOnly.label.txt': () => `Nur Arbeitsbereich anzeigen:`,
  'PlaybackAnimationDialog.showTimer.label.txt': () => `Timer anzeigen:`,
  'PlaybackAnimationDialog.showNavigationControls.label.txt': () => `Navigationssteuerungen bei Klick oder Berührung anzeigen:`,
  'PlaybackNavigationControls.previousPage.txt': () => `Vorherige Seite`,
  'PlaybackNavigationControls.nextPage.txt': () => `Nächste Seite`,
  'PlaybackNavigationControls.previousObject.txt': () => `Vorheriges Objekt`,
  'PlaybackNavigationControls.nextObject.txt': () => `Nächstes Objekt`,
  'TransportConnection.generateReportTimeout.txt': () => `Das Laden des Berichts nimmt sehr viel Zeit in Anspruch. Fortfahren?`,
  'TransportConnection.openReport.txt': () => `Bericht öffnen`,
  'ViewerContainer.reportNotFound.fmt': ({location}) => `Der angegebene Bericht im folgenden Speicherort existiert nicht: ${location}`,
  'Hierarchy.expand.fmt': ({label}) => `${label} aufklappen`,
  'Hierarchy.collapse.fmt': ({label}) => `${label} zuklappen`,
  'GraphElementDecorator.overview.txt': () => `Übersicht`,
  'GraphElementDecorator.layers.txt': () => `Ebenen ein-/ausblenden`,
  'CompositeGraphElementDecorator.hideOverview.txt': () => `Übersicht ausblenden`,
  'CompositeGraphElementDecorator.showOverview.txt': () => `Übersicht anzeigen`,
  'TitleInfoButton.tooltip.txt': () => `Informationen`,
  'SectionSelectionBar.noSelections.txt': () => `Keine Auswahl`,
  'SectionSelectionBar.title.txt': () => `Filter:`,
  'CheckboxList.selectAll.txt': () => `Alles auswählen`,
  'CheckboxList.clearSelection.txt': () => `Auswahl aufheben`,
  'CheckboxList.clearSelection.fmt': ({count}) => `Auswahl aufheben (${count})`,
  'ExplanationInfoDialog.title.fmt': ({label}) => `Erklären von ${label}`,
  'ExplanationInfoDialog.loading.txt': () => `Erklärung wird vorbereitet...`,
  'ExplanationInfoDialog.cancel.txt': () => `Abbrechen`,
  'ExplanationInfoDialog.close.txt': () => `Schließen`,
  'PromptHeader.emptyReport.txt': () => `Datenelement oder Steuerelement hierhin ziehen, um eine Berichtseingabeaufforderung zu erstellen.`,
  'PromptHeader.emptyPage.txt': () => `Datenelement oder Steuerelement hierhin ziehen, um eine Seiteneingabeaufforderung zu erstellen.`,
  'PromptHeader.collapsePageControlArea.txt': () => `Seitensteuerung zuklappen`,
  'PromptHeader.expandPageControlArea.txt': () => `Seitensteuerung aufklappen`,
  'PromptHeader.collapseReportControlArea.txt': () => `Berichtssteuerung zuklappen`,
  'PromptHeader.expandReportControlArea.txt': () => `Berichtssteuerung aufklappen`,
  'PromptHeader.collapseControlArea.txt': () => `Steuerung zuklappen`,
  'PromptHeader.expandControlArea.txt': () => `Steuerung aufklappen`,
  'PromptHeader.reportControlArea.txt': () => `Berichtssteuerung`,
  'PromptHeader.allControlAreas.txt': () => `Alle Steuerungen`,
  'PromptHeader.pageControlArea.txt': () => `Seitensteuerung`,
  'ZeroState.editMode.txt': () => `Eine Vorlage, Datenelemente oder Objekte hierhin ziehen.`,
  'ZeroState.viewMode.txt': () => `Kein anzuzeigender Inhalt vorhanden.`,
  'ObjectStatus.assignData.txt': () => `Daten zuweisen`,
  'ObjectStatus.selectImage.txt': () => `Bild auswählen`,
  'ObjectStatus.selectJob.txt': () => `Job auswählen`,
  'ObjectStatus.cancelLoading.txt': () => `Ladevorgang abbrechen`,
  'ObjectStatus.loadingCanceled.txt': () => `Ladevorgang abgebrochen`,
  'ObjectStatus.resumeLoading.txt': () => `Ladevorgang fortsetzen`,
  'ObjectStatus.refresh.txt': () => `Aktualisieren`,
  'ObjectStatus.setJobParameters.txt': () => `Parameterwerte festlegen`,
  'ObjectSearch.title.txt': () => `Geografische Suche`,
  'ObjectSearch.pin.txt': () => `Anheften`,
  'ObjectSearch.unpin.txt': () => `Ablösen`,
  'MainSearchPanel.searchHints.txt': () => `Suchhinweise`,
  'MainSearchPanel.searchResults.txt': () => `Suchergebnisse`,
  'MainSearchPanel.features.txt': () => `Funktionen`,
  'MainSearchPanel.pin.txt': () => `Neue Stecknadel`,
  'MainSearchPanel.pin.tooltip.txt': () => `Neue Stecknadel`,
  'MainSearchPanel.route.txt': () => `Neue Route`,
  'MainSearchPanel.route.tooltip.txt': () => `Neue Route`,
  'MainSearchPanel.geographicArea.txt': () => `Neues geografisches Gebiet`,
  'MainSearchPanel.geographicArea.tooltip.txt': () => `Neues geografisches Gebiet`,
  'MainSearchPanel.newMyLocationPin.txt': () => `Meine Standort-Stecknadel`,
  'MainSearchPanel.myLocationPin.txt': () => `Mein Standort`,
  'MainSearchPanel.show.txt': () => `Anzeigen`,
  'MainSearchPanel.show.all.txt': () => `Alle anzeigen`,
  'MainSearchPanel.hide.txt': () => `Ausblenden`,
  'MainSearchPanel.hide.all.txt': () => `Alle ausblenden`,
  'MainSearchPanel.delete.txt': () => `Löschen`,
  'MainSearchPanel.delete.all.txt': () => `Alle löschen`,
  'MainSearchPanel.convert.txt': () => `Suchergebnisse in Stecknadeln umwandeln`,
  'MainSearchPanel.convert.all.txt': () => `Alle Suchergebnisse in Stecknadeln umwandeln`,
  'MainSearchPanel.showPinLabels.txt': () => `Stecknadeletiketten anzeigen`,
  'MainSearchPanel.close.label.txt': () => `Geografische Suche`,
  'MainSearchPanel.navigate.tooltip.txt': () => `Details anzeigen`,
  'MainSearchPanel.demographics.tooltip.txt': () => `Demografiedaten`,
  'PanelHeader.back.tooltip.txt': () => `Zurück`,
  'GeographicAreaPanel.title.txt': () => `Geografisches Gebiet`,
  'GeographicAreaPanel.draw.txt': () => `Gebiet zeichnen`,
  'GeographicAreaPanel.update.txt': () => `Gebiet aktualisieren`,
  'GeographicAreaPanel.label.txt': () => `Etikett:`,
  'GeographicAreaPanel.location.txt': () => `Standort:`,
  'GeographicAreaPanel.distance.miles.txt': () => `Strecke (mi):`,
  'GeographicAreaPanel.distance.kilometer.txt': () => `Strecke (km):`,
  'GeographicAreaPanel.distance.add.txt': () => `Strecke hinzufügen`,
  'GeographicAreaPanel.time.add.txt': () => `Zeit hinzufügen`,
  'GeographicAreaPanel.distance.delete.txt': () => `Strecke löschen`,
  'GeographicAreaPanel.time.minutes.txt': () => `Zeit (Min):`,
  'GeographicAreaPanel.duration.txt': () => `Dauer:`,
  'GeographicAreaPanel.distanceUnits.miles.txt': () => `Meilen`,
  'GeographicAreaPanel.distanceUnits.kilometers.txt': () => `Kilometer`,
  'GeographicAreaPanel.menu.clear.txt': () => `Geografisches Gebiet löschen`,
  'GeographicAreaPanel.menu.link.txt': () => `Adresse standardmäßig mit Datenelementen und Stecknadeln verknüpfen`,
  'GeographicAreaPanel.menu.unlink.txt': () => `Verknüpfung mit Adresse des geografischen Gebiets aufheben`,
  'GeographicAreaPanel.menu.delete.txt': () => `Geografisches Gebiet löschen`,
  'GeographicAreaPanel.demographics.txt': () => `Demografiedaten`,
  'GeographicAreaPanel.demographics.set.txt': () => `Demografiedaten anzeigen`,
  'GeographicAreaPanel.demographics.menu.expand.txt': () => `Ansicht erweitern`,
  'GeographicAreaPanel.demographics.menu.edit.txt': () => `Demografiedaten bearbeiten`,
  'GeographicAreaPanel.demographics.menu.delete.txt': () => `Demografiedaten löschen`,
  'GeographicAreaPanel.demographics.expired.txt': () => `Demografiedaten müssen neu geladen werden`,
  'GeographicAreaPanel.demographics.reload.txt': () => `Demografiedaten neu laden`,
  'GeographicAreaPanel.invalid.location.txt': () => `Das geografische Gebiet hat keinen gültigen Standort und kann nicht erstellt werden.`,
  'TravelTypeField.dateselector.tooltip.txt': () => `Tag und Uhrzeit auswählen`,
  'TravelTypeField.cancel.txt': () => `Abbrechen`,
  'TravelTypeField.ok.txt': () => `OK`,
  'TravelTypeField.button.tooltip.txt': () => `Tag und Uhrzeit auswählen`,
  'TravelTypeField.day.txt': () => `Tag:`,
  'TravelTypeField.time.txt': () => `Uhrzeit:`,
  'TravelTypeField.distanceTypes.direct.txt': () => `Direkt`,
  'TravelTypeField.distanceTypes.distance.txt': () => `Strecke`,
  'TravelTypeField.travelType.txt': () => `Fahrtmodus:`,
  'TravelTypeField.traffic.txt': () => `Verkehrslage berücksichtigen:`,
  'TravelTypeField.traffic.offset.txt': () => `Verkehrszeitverschiebung:`,
  'TravelTypeField.traffic.daytime.txt': () => `Verkehr Tag und Uhrzeit:`,
  'TravelTypeField.distanceTypes.distance.unit.txt': () => `Einheit Strecke`,
  'TravelTypeField.distanceTypes.driving.distance.txt': () => `Fahrstrecke`,
  'TravelTypeField.distanceTypes.driving.time.txt': () => `Fahrtdauer`,
  'TravelTypeField.distanceTypes.trucking.distance.txt': () => `LKW-Fahrstrecke`,
  'TravelTypeField.distanceTypes.trucking.time.txt': () => `LKW-Fahrtdauer`,
  'TravelTypeField.distanceTypes.walking.distance.txt': () => `Gehstrecke`,
  'TravelTypeField.distanceTypes.walking.time.txt': () => `Gehdauer`,
  'TravelTypeField.driveTimeTrafficTypes.none.txt': () => `Nein`,
  'TravelTypeField.driveTimeTrafficTypes.live.txt': () => `Aktuelle Verkehrslage`,
  'TravelTypeField.driveTimeTrafficTypes.historic.txt': () => `Typische Verkehrslage`,
  'TravelTypeField.driveTimeTraffic.offset.fmt': ({hour}) => `${hour} Std.`,
  'TravelTypeField.driveTimeTraffic.update.refresh.txt': () => `Verkehrslage für diese Funktion aktualisieren`,
  'TravelTypeField.driveTimeTraffic.update.refreshAll.txt': () => `Verkehrslage für alle Funktionen aktualisieren`,
  'TravelTypeField.driveTimeTraffic.update.tooltip.txt': () => `Verkehrslagedaten aktualisieren`,
  'RoutePanel.title.txt': () => `Route`,
  'RoutePanel.draw.txt': () => `Route zeichnen`,
  'RoutePanel.update.txt': () => `Route aktualisieren`,
  'RoutePanel.label.txt': () => `Etikett:`,
  'RoutePanel.locations.txt': () => `Standorte`,
  'RoutePanel.menu.clear.txt': () => `Route löschen`,
  'RoutePanel.menu.reverse.txt': () => `Route umkehren`,
  'RoutePanel.menu.add.waypoint.txt': () => `Routenstandort hinzufügen`,
  'RoutePanel.menu.delete.waypoint.txt': () => `Routenstandort löschen`,
  'RoutePanel.menu.unlink.txt': () => `Routenstandortverlinkung aufheben`,
  'RoutePanel.menu.arrows.txt': () => `Routenpfeile`,
  'RoutePanel.menu.arrows.hide.txt': () => `Routenpfeile ausblenden`,
  'RoutePanel.menu.arrows.show.txt': () => `Routenpfeile anzeigen`,
  'RoutePanel.menu.arrows.oneway.txt': () => `Einseitig`,
  'RoutePanel.menu.arrows.twoway.txt': () => `Beidseitig`,
  'RoutePanel.menu.delete.txt': () => `Route löschen`,
  'RoutePanel.route.width.txt': () => `Routenbreite`,
  'RoutePanel.distance.txt': () => `Distanz:`,
  'RoutePanel.distance.miles.fmt': ({distance}) => `${distance} Mi`,
  'RoutePanel.distance.kilometers.fmt': ({distance}) => `${distance} Km`,
  'RoutePanel.location.add.txt': () => `Standort hinzufügen`,
  'RoutePanel.location.delete.txt': () => `Standort löschen`,
  'RoutePanel.duration.txt': () => `Uhrzeit:`,
  'RoutePanel.invalid.location.txt': () => `Die Route enthält keine gültigen Standorte und kann nicht erstellt werden.`,
  'RoutePanel.accessibilityCellInfo.fmt': ({index, location}) => `Standort ${index}, ${location}, Eingabe`,
  'PinPanel.pinTitle.txt': () => `Stecknadel`,
  'PinPanel.addDescription.txt': () => `Beschreibung hinzufügen`,
  'PinPanel.deleteDescription.txt': () => `Beschreibung löschen`,
  'PinPanel.newPin.txt': () => `Neue Stecknadel an dieser Stelle`,
  'PinPanel.deletePin.txt': () => `Stecknadel löschen`,
  'PinPanel.linkPins.txt': () => `Stecknadeln standardmäßig mit Datenelementen verknüpfen`,
  'PinPanel.unlinkAllItems.txt': () => `Verknüpfung aller Elemente aufheben`,
  'PinPanel.unlinkItems.txt': () => `Verknüpfung von Elementen aufheben`,
  'PinPanel.label.txt': () => `Etikett:`,
  'PinPanel.location.txt': () => `Standort:`,
  'PinPanel.description.txt': () => `Beschreibung:`,
  'PinPanel.linked.txt': () => `VERKNÜPFT`,
  'PinPanel.searchClickPlaceholder.txt': () => `Suchen oder in Karte auswählen`,
  'PinPanel.searchPlaceholder.txt': () => `Suchen`,
  'PinPanel.addRoute.txt': () => `Route hinzufügen`,
  'PinPanel.addRoute.tooltip.txt': () => `Route hinzufügen`,
  'PinPanel.addArea.txt': () => `Geografisches Gebiet hinzufügen`,
  'PinPanel.addArea.tooltip.txt': () => `Geografisches Gebiet hinzufügen`,
  'PinPanel.addArea.title.txt': () => `Geografisches Gebiet hinzufügen`,
  'PinPanel.myLocationTitle.txt': () => `Mein Standort-Stecknadel`,
  'PinPanel.deleteMyLocationPin.txt': () => `Mein Standort-Stecknadel löschen`,
  'PinPanel.enableAutoUpdate.txt': () => `Auto-Aktualisierung für Mein Standort aktivieren`,
  'PinPanel.disableAutoUpdate.txt': () => `Auto-Aktualisierung für Mein Standort deaktivieren`,
  'PinPanel.editAutoRefreshInterval.txt': () => `Auto-Aktualisierungsintervall für Mein Standort bearbeiten...`,
  'PinPanel.linkToPin.txt': () => `Mit Stecknadel verknüpfen`,
  'PinPanel.useCurrentLocation.txt': () => `Aktuellen Stecknadelstandort verwenden`,
  'PinPanel.notDrawn.txt': () => `Nicht gezeichnet`,
  'PinPanel.undetermined.txt': () => `Unbestimmt`,
  'PinPanel.findMyLocation.txt': () => `Mein Standort suchen`,
  'PinPanel.cannotDetermineLocation.txt': () => `Die Anwendung kann Ihren aktuellen Standort nicht ermitteln. Wenn Sie Ihren Standort teilen möchten, lesen Sie die Hilfe für Ihren Browser oder Ihr Gerät.`,
  'PinPanel.autoRefreshInterval.txt': () => `Auto-Aktualisierungsintervall für Mein Standort`,
  'PinPanel.interval.hours.txt': () => `Stunden:`,
  'PinPanel.interval.minutes.txt': () => `Minuten:`,
  'PinPanel.interval.seconds.txt': () => `Sekunden:`,
  'PinPanel.invalid.location.txt': () => `Die Stecknadel hat keinen gültigen Standort und kann nicht erstellt werden.`,
  'PinPanel.description.miles.1.fmt': ({value1}) => `${value1} mi`,
  'PinPanel.description.miles.2.fmt': ({value1, value2}) => `${value1}; ${value2} mi`,
  'PinPanel.description.miles.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} mi`,
  'PinPanel.description.kilometers.1.fmt': ({value1}) => `${value1} km`,
  'PinPanel.description.kilometers.2.fmt': ({value1, value2}) => `${value1}; ${value2} km`,
  'PinPanel.description.kilometers.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} km`,
  'PinPanel.description.minutes.1.fmt': ({value1}) => `${value1} min`,
  'PinPanel.description.minutes.2.fmt': ({value1, value2}) => `${value1}; ${value2} min`,
  'PinPanel.description.minutes.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} min`,
  'PinPanel.clearLocation.tooltip.txt': () => `Standorttext löschen`,
  'DiscardChangesDialog.title.area.txt': () => `Geografisches Gebiet`,
  'DiscardChangesDialog.title.route.txt': () => `Route`,
  'DiscardChangesDialog.text.area.txt': ({label}) => `Sie haben Änderungen am geografischen Gebiet vorgenommen, das Gebiet jedoch nicht neu gezeichnet.\n\nMöchten Sie diese Änderungen in ${label} verwerfen?`,
  'DiscardChangesDialog.text.route.txt': ({label}) => `Sie haben Änderungen an geografischen Route vorgenommen, die Route jedoch nicht neu gezeichnet.\n\nMöchten Sie diese Änderungen in ${label} verwerfen?`,
  'DiscardChangesDialog.discard.txt': () => `Verwerfen`,
  'DiscardChangesDialog.cancel.txt': () => `Abbrechen`,
  'FeatureErrorDialog.title.area.txt': () => `Geografisches Gebiet zeichnen`,
  'FeatureErrorDialog.title.route.txt': () => `Route zeichnen`,
  'FeatureErrorDialog.text.area.txt': () => `Das geografische Gebiet konnte nicht gezeichnet werden.\n\nTipp: Wenn der Standort Ihres Gebiets keine Verkehrsinfrastruktur wie Straßen enthält, kann ein geografisches Gebiet möglicherweise nicht berechnet werden. Verwenden Sie stattdessen den Reisetyp Strecke, oder verschieben Sie das Gebiet an einen Ort mit entsprechender Infrastruktur.`,
  'FeatureErrorDialog.text.route.txt': () => `Die Route konnte nicht gezeichnet werden.\n\nTipp: Wenn der Standort Ihrer Route keine Verkehrsinfrastruktur wie Straßen enthält, kann die Route möglicherweise nicht berechnet werden. Verwenden Sie stattdessen den Reisetyp Strecke, oder verschieben Sie die Route an einen Ort mit entsprechender Infrastruktur.`,
  'FeatureErrorDialog.close.txt': () => `Schließen`,
  'DemographicsSelectorDialog.title.txt': () => `Demografiedaten anzeigen`,
  'DemographicsSelectorDialog.cancel.txt': () => `Abbrechen`,
  'DemographicsSelectorDialog.ok.txt': () => `OK`,
  'DemographicsSelectorDialog.country.txt': () => `Land/Region`,
  'DemographicsSelectorDialog.tab.basic.txt': () => `Einfach`,
  'DemographicsSelectorDialog.tab.advanced.txt': () => `Erweitert`,
  'DemographicsSelectorDialog.tab.recent.txt': () => `Zuletzt`,
  'DemographicsSelectorDialog.categories.txt': () => `Kategorien`,
  'DemographicsSelectorDialog.category.income.txt': () => `Einkommen`,
  'DemographicsSelectorDialog.category.age.txt': () => `Alter`,
  'DemographicsSelectorDialog.category.households.txt': () => `Haushalte`,
  'DemographicsSelectorDialog.category.housing.txt': () => `Wohnen`,
  'DemographicsSelectorDialog.category.maritalstatus.txt': () => `Familienstand`,
  'DemographicsSelectorDialog.category.population.txt': () => `Bevölkerung`,
  'DemographicsSelectorDialog.category.usergroup.txt': () => `Benutzergruppe`,
  'DemographicsSelectorDialog.category.health.txt': () => `Gesundheit`,
  'DemographicsSelectorDialog.category.education.txt': () => `Bildung`,
  'DemographicsSelectorDialog.category.business.txt': () => `Arbeit`,
  'DemographicsSelectorDialog.category.race.txt': () => `Ethnische Zugehörigkeit`,
  'DemographicsSelectorDialog.category.spending.txt': () => `Ausgaben`,
  'DemographicsSelectorDialog.category.behaviors.txt': () => `Lebensstil`,
  'DemographicsSelectorDialog.category.jobs.txt': () => `Beschäftigung`,
  'DemographicsSelectorDialog.category.poverty.txt': () => `Armut`,
  'DemographicsSelectorDialog.category.tapestry.txt': () => `Soziales Umfeld`,
  'DemographicsSelectorDialog.category.atrisk.txt': () => `Risikostatus`,
  'DemographicsSelectorDialog.category.keyfacts.txt': () => `Schlüsselfakten`,
  'DemographicsSelectorDialog.category.supplyanddemand.txt': () => `Angebot und Nachfrage`,
  'DemographicsSelectorDialog.category.policy.txt': () => `Politik`,
  'DemographicsSelectorDialog.category.landscape.txt': () => `Landschaft`,
  'DemographicsSelectorDialog.category.crime.txt': () => `Kriminalität`,
  'ManageColumns.title.txt': () => `Spalten verwalten`,
  'ManageColumns.ok.txt': () => `OK`,
  'ManageColumns.cancel.txt': () => `Abbrechen`,
  'ManageColumns.hiddenColumns.txt': () => `Ausgeblendete Spalten`,
  'ManageColumns.displayedColumns.txt': () => `Angezeigte Spalten`,
  'SearchResultPanel.title.txt': () => `Suchergebnis`,
  'SearchResultPanel.menu.delete.txt': () => `Suchergebnis löschen`,
  'SearchResultPanel.convert.txt': () => `In Stecknadel umwandeln`,
  'SearchResultPanel.convert.tooltip.txt': () => `In Stecknadel umwandeln`,
  'DemographicsResultsDialog.title.txt': () => `Demografiedaten`,
  'DemographicsResultsDialog.cancel.txt': () => `Abbrechen`,
  'DemographicsResultsDialog.close.txt': () => `Schließen`,
  'DemographicsResultsDialog.edit.txt': () => `Bearbeiten`,
  'DemographicsResultsDialog.layout.page.txt': () => `Karussellansicht`,
  'DemographicsResultsDialog.layout.list.txt': () => `Einspaltige Ansicht`,
  'DemographicsResultsDialog.layout.tile.txt': () => `Kachelansicht`,
  'DemographicsResultsDialog.noData.txt': () => `Keine der Daten stimmen mit dem aktuellen geografischen Gebiet überein.`,
  'PinsAtSameLocationPanel.title.txt': () => `Stecknadeln an selber Position`,
  'PinsAtSameLocationPanel.searchResults.txt': () => `SUCHERGEBNISSE`,
  'PinsAtSameLocationPanel.pins.txt': () => `STECKNADELN`,
  'PinsAtSameLocationPanel.showAll.txt': () => `Alle anzeigen`,
  'PinsAtSameLocationPanel.hideAll.txt': () => `Alle ausblenden`,
  'PinsAtSameLocationPanel.deleteAll.txt': () => `Alle löschen`,
  'PinsAtSameLocationPanel.show.txt': () => `Anzeigen`,
  'PinsAtSameLocationPanel.hide.txt': () => `Ausblenden`,
  'PinsAtSameLocationPanel.delete.txt': () => `Löschen`,
  'LocationPopover.pin.title.txt': () => `Stecknadelposition`,
  'LocationPopover.area.title.txt': () => `Geografischer Bereich`,
  'LocationPopover.route.title.txt': ({label}) => `Routenposition ${label}`,
  'LocationPopover.name.txt': () => `Name`,
  'LocationPopover.location.txt': () => `Standort:`,
  'LocationPopover.ok.txt': () => `Standort festlegen`,
  'LocationPopover.cancel.txt': () => `Auswahlmodus beenden`,
  'LocationPopover.hint.txt': () => `Klicken Sie erneut auf die Karte, um einen anderen Standort zu bestimmen.`,
  'TreeDualSelector.source.default.txt': () => `Verfügbare Elemente`,
  'TreeDualSelector.target.default.txt': () => `Ausgewählte Elemente`,
  'TreeDualSelector.filtered.length.fmt': ({label, filteredLength, totalLength}) => `${label} (${filteredLength} von ${totalLength}):`,
  'TreeDualSelector.item.length.fmt': ({label, length}) => `${label} (${length}):`,
  'TreeDualSelector.emptymessage.txt': () => `Keine Elemente`,
  'TreeDualSelector.filter.placeholder.txt': () => `Filter`,
  'TreeDualSelector.customItem.choiceIcon.tooltip.txt': () => `Benutzerdefiniertes Element`,
  'TreeDualSelector.afterAction.add.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} Elemente hinzugefügt`,
  'TreeDualSelector.afterAction.remove.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} Elemente entfernt`,
  'TreeDualSelector.afterAction.addAll.txt': () => `Alle Elemente werden hinzugefügt`,
  'TreeDualSelector.afterAction.removeAll.txt': () => `Alle Elemente werden entfernt`,
  'TreeDualSelector.afterAction.up.txt': () => `Nach oben verschoben`,
  'TreeDualSelector.afterAction.down.txt': () => `Nach unten verschoben`,
  'TreeDualSelector.afterAction.top.txt': () => `An den Anfang verschoben`,
  'TreeDualSelector.afterAction.bottom.txt': () => `An das Ende verschoben`,
  'TreeDualSelector.afterAction.undo.add.txt': () => `Aktion hinzufügen rückgängig gemacht`,
  'TreeDualSelector.afterAction.undo.remove.txt': () => `Aktion Entfernen rückgängig gemacht`,
  'TreeDualSelector.afterAction.customAdd.txt': () => `benutzerdefiniertes Element hinzugefügt`,
  'TreeDualSelector.customItemSelection.fmt': ({customItemSelected}) => `${customItemSelected} benutzerdefiniertes Element ausgewählt`,
  'TreeDualSelector.itemSelectionWithDescription.fmt': ({itemSelected, itemDescription}) => `${itemSelected} ${itemDescription} ausgewählt`,
  'TreeDualSelector.itemSelection.fmt': ({itemSelected}) => `${itemSelected} ausgewählt`,
  'TreeDualSelector.reorderButton.up.button.aria': ({targetListLabel}) => `Um eine Zeile in ${targetListLabel} nach oben verschieben`,
  'TreeDualSelector.reorderButton.down.button.aria': ({targetListLabel}) => `Um eine Zeile in ${targetListLabel} nach unten verschieben`,
  'TreeDualSelector.reorderButton.top.button.aria': ({targetListLabel}) => `An den Anfang von ${targetListLabel} verschieben`,
  'TreeDualSelector.reorderButton.bottom.button.aria': ({targetListLabel}) => `An das Ende von ${targetListLabel} verschieben`,
  'TreeDualSelector.moveButton.add.button.aria': ({targetListLabel}) => `Element hinzufügen zu ${targetListLabel}`,
  'TreeDualSelector.moveButton.addall.button.aria': ({targetListLabel}) => `Alle hinzufügen zu ${targetListLabel}`,
  'TreeDualSelector.moveButton.remove.button.aria': ({targetListLabel}) => `Element entfernen aus ${targetListLabel}`,
  'TreeDualSelector.moveButton.removeall.button.aria': ({targetListLabel}) => `Alle entfernen aus ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoadd.button.aria': ({targetListLabel}) => `Hinzufügen rückgängig machen für ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoremove.button.aria': ({targetListLabel}) => `Entfernen rückgängig machen für ${targetListLabel}`,
  'TreeDualSelector.searchField.aria': ({listLabel}) => `${listLabel} filtern`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.title': () => `Entfernen`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.txt': () => `Wenn Sie fortfahren, werden alle zum Entfernen ausgewählten benutzerdefinierten Elemente dauerhaft gelöscht.\n\n Fortfahren?`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.title': () => `Alle Elemente entfernen`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.txt': () => `Wenn Sie fortfahren, werden die benutzerdefinierten Elemente in dieser Liste dauerhaft gelöscht.\n\n Fortfahren?`,
  'LinkNavigator.backButton.label': () => `Zurück`,
  'LinkNavigator.rootOrReportLinkBreadcrumb.label': ({reportLabel, sectionLabel}) => `${reportLabel}: ${sectionLabel}`,
  'LinkNavigator.incomingFilters.title': () => `Angewendete Filter`,
  'LinkNavigator.reportLevel.label': () => `Berichtsebene`,
  'LinkNavigator.sectionLevel.label': () => `Seitenebene`,
  'ReportSectionZeroState.heading.label': () => `Bericht entwerfen`,
  'ReportSectionZeroState.description.label': () => `Ziehen Sie Objekte oder Datenelemente auf die Seite oder wählen Sie unten eine Option aus.`,
  'ReportSectionZeroState.hideAutoChartButton.description.label': () => `Ziehen Sie Objekte oder Datenelemente auf die Seite, oder verwenden Sie eine Seitenvorlage, um zu beginnen.`,
  'ReportSectionZeroState.autoChartButton.label': () => `Objekt generieren`,
  'ReportSectionZeroState.selectTemplateButton.label': () => `Vorlage auswählen`,
  'ReportSectionZeroState.exploreSuggestions.label': () => `Vorschläge untersuchen`,
  'PromptContainerTooltip.noSelections.txt': () => `Keine Auswahl`,
  'PromptContainerTooltip.selectedValues.txt': () => `Ausgewählte Werte`,
}
export default localizers;
